import { makeObservable, observable, action } from 'mobx';
import { SourceModelBase } from '..';
import { CustomStaticSource, CustomSourceData } from '../../types';

export default class StaticSourceModel extends SourceModelBase {
    data: CustomSourceData[];

    constructor(source: CustomStaticSource) {
        super(source);

        this.data = source.data ?? [];

        makeObservable(this, {
            data: observable,
            update: action
        });
    }

    update(source: CustomStaticSource) {
        this.data = source.data ?? [];
    }

    async getSources(): Promise<CustomSourceData[]> {
        return this.filterData(this.data);
    }
}
